import { Component, Inject, OnDestroy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions
} from '@angular/material/dialog';
import { ConfigService } from '../../services/config.service';
import { DepotLocation } from '../../../models';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { PriceContainerStore } from '../../price-container-v2/price-container.store';
import {
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule
} from '@angular/forms';
import { HlCurrencyPipe } from '../../pipes/hl-currency.pipe';
import { UserIdToNamePipe } from '../../pipes/user-id-to-name.pipe';
import { MomentModule } from 'ngx-moment';
import { MatInput } from '@angular/material/input';
import { AddCurrencyPrefixDirective } from '../../directives/add-currency-prefix.directive';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import {
  MatFormField,
  MatLabel,
  MatPrefix
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton, MatButton } from '@angular/material/button';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-add-payment-dialog',
  templateUrl: './add-payment-dialog.component.html',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    NgIf,
    NgFor,
    MatIconButton,
    MatIcon,
    ReactiveFormsModule,
    MatFormField,
    MatSelect,
    MatOption,
    MatLabel,
    MatPrefix,
    AddCurrencyPrefixDirective,
    MatInput,
    MatDialogActions,
    MatButton,
    AsyncPipe,
    MomentModule,
    UserIdToNamePipe,
    HlCurrencyPipe
  ]
})
export class AddPaymentV2DialogComponent implements OnDestroy {
  vm$ = this.priceContainerStore.vm$;
  methods = ['Cash', 'Cheque', 'Card', 'Bank Transfer'];
  dateTimeFormat = ConfigService.dates.longDateTimeFormat;
  private ngUnsubscribe = new Subject<void>();
  currentLcation: DepotLocation;
  newPayment = new FormGroup({
    method: new FormControl<string>('', Validators.required),
    amount: new FormControl<number>(null, Validators.required)
  });
  loading$ = this.vm$.pipe(map((vm) => vm.loading));

  constructor(
    public dialogRef: MatDialogRef<AddPaymentV2DialogComponent>,
    private configService: ConfigService,
    private priceContainerStore: PriceContainerStore,
    @Inject(MAT_DIALOG_DATA)
    public data: { currency: string; currencyRate: number }
  ) {
    this.configService.currentLocation
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((location) => {
        this.currentLcation = location;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  save() {
    if (!this.newPayment.value.method || !this.newPayment.value.amount) {
      return;
    }
    const submission = {
      ...this.newPayment.value,
      amount: this.newPayment.value.amount / this.data.currencyRate,
      location_id: this.currentLcation.id
    };

    this.priceContainerStore.addPayment({
      payment: submission,
      onComplete: () => this.dialogRef.close()
    });
  }

  delete(payment) {
    this.priceContainerStore.deletePayment(payment.id);
  }
}
